import React from 'react';
import { Menu } from 'lucide-react';

/**
 * 페이지 상단 헤더 컴포넌트
 * @param {string} activeTab - 현재 선택된 탭 ('chat', 'history', 'faq')
 * @param {string} viewMode - 질의 현황 탭의 뷰 모드 ('personal', 'company')
 * @param {function} setViewMode - 뷰 모드 변경 함수
 * @param {function} onToggleSidebar - 사이드바 토글 함수
 * @param {object} currentUser - 현재 로그인 사용자 정보 (role 기반 UI 제어용)
 */
const PageHeader = ({ activeTab, viewMode, setViewMode, onToggleSidebar, currentUser, isSidebarOpen }) => {
    // R0(관리자): 전체 고정, R2(회사 관리자): 회사별 고정, R3(개인): 개인별 고정
    // 세 역할 모두 토글 버튼을 숨겨 다른 모드로 전환하지 못하게 합니다.
    const isViewModeLocked = currentUser?.role === 'R0' || currentUser?.role === 'R2' || currentUser?.role === 'R3';

    return (
        <header className="h-14 sm:h-16 flex items-center justify-between px-3 sm:px-6 bg-white/80 backdrop-blur-md sticky top-0 z-10 border-b border-gray-50">
            <div className="flex items-center gap-2 sm:gap-4">
                {isSidebarOpen && (
                    <>
                        <button
                            onClick={onToggleSidebar}
                            className="p-1.5 sm:p-2 hover:bg-gray-100 rounded-full transition text-gray-500"
                        >
                            <Menu size={20} className="sm:size-6" />
                        </button>
                    </>
                )}
                <h2 className="font-bold text-gray-700 text-base sm:text-lg truncate">
                            {activeTab === 'chat' && 'AI 안전 전문가'}
                            {activeTab === 'history' && '질의 현황 관리'}
                            {activeTab === 'faq' && '자주 묻는 질문 (FAQ)'}
                        </h2>
            </div>

            {/* 역할이 R2/R3가 아닌 경우에만 토글 스위치를 표시합니다. */}
            {activeTab === 'history' && !isViewModeLocked && (
                <div className="flex bg-gray-100 rounded-full p-1 border scale-90">
                    <button
                        onClick={() => setViewMode('personal')}
                        className={`px-5 py-1.5 rounded-full text-sm font-bold transition-all ${viewMode === 'personal' ? 'bg-white shadow text-blue-600' : 'text-gray-500'}`}
                    >
                        개인
                    </button>
                    <button
                        onClick={() => setViewMode('company')}
                        className={`px-5 py-1.5 rounded-full text-sm font-bold transition-all ${viewMode === 'company' ? 'bg-white shadow text-blue-600' : 'text-gray-500'}`}
                    >
                        회사
                    </button>
                </div>
            )}
        </header>
    );
};

export default PageHeader;

